import Vue from 'vue';
import directives from './index';

Object.keys(directives).forEach(directiveName => {
  Vue.directive(directiveName, directives[directiveName]);
});
